module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/from-browser.js